<template>
  <div class="input__datalists text-left pt-5 relative">
    <label class="block pb-2" :for="id"
      >{{ label }}
      <span class="text-status-error" v-if="required && label">*</span>
      <slot name="label"></slot>
    </label>
    <div
      :class="`relative border border-transparent transition-all rounded-md ${
        disabled ||
        (select != '0' && !select && !isFocus && select == '') ||
        select === null
          ? 'bg-neutral-9'
          : 'bg-white'
      } ${isFocus ? 'border-blue-primary' : ''}`"
    >
      <div
        class="px-2 h-10 flex place-items-center bg-neutral-9 rounded-md cursor-not-allowed"
        v-if="isDetail"
      >
        {{ showDetail }}
      </div>
      <v-select
        v-else
        class="p-0.5"
        v-on:input="select = $event"
        :value="select"
        :reduce="listValue ? (lists) => lists[listValue] : (lists) => lists"
        :options="lists"
        :placeholder="placeholder || ''"
        :label="listShow ? listShow : lists"
        :id="id"
        :disabled="disabled"
        @search:focus="isFocus = true"
        @search:blur="isFocus = false"
      >
        <template v-slot:no-options>
          <div class="text-status-error">Tidak dapat menemukan data.</div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      isFocus: false,
    };
  },
  props: {
    /**
     * ID Wajib di isi, supaya ketika label di klik bisa otomatis focus input
     */
    id: {
      type: [String, Number],
      required: true,
    },
    lists: {
      type: Array,
      default: () => [],
    },
    /**
     * Tulisan yang ada diatas input persis.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * Text yang akan tampil apabila input kosong.
     */
    placeholder: {
      type: [String, Boolean],
      default: "",
    },
    /**
     * ketika benar maka muncul tanda bintang
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * ketika benar maka input jadi disable dan tidak bisa untuk input
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String, Array, Boolean, Object],
      default: "",
    },
    /**
     * object yang akan ditampilkan
     */
    listShow: {
      type: String,
      default: "show",
    },
    /**
     * Object yang akan jadi value
     */
    listValue: {
      type: String,
      default: "",
    },
    /**
     * ketika benar menjadi tipe detail dan tidak bisa menginput
     */
    isDetail: {
      type: Boolean,
      default: false,
    },
    int: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    select: {
      get() {
        return this.value;
      },
      set(event) {
        if (this.int) {
          event = parseInt(event) || event;
        }
        // console.log("datalist event", event);
        this.$emit("input", event);
      },
    },
    showDetail() {
      return (
        this.lists?.find((data) => data[this.listValue] == this.select)?.[
          this.listShow
        ] ||
        this.select ||
        ""
      );
    },
  },

  mounted() {
    (this.value || this.value == 0) && (this.select = this.value);
    console.log("dataList", typeof this.select);
  },
};
</script>

<style lang="scss">
.input__datalists {
  input:disabled {
    @apply bg-neutral-9 cursor-not-allowed #{!important};
  }
}
</style>
